<ng-container *ngIf="instruction && getImageUrl()">
    <a *ngIf="instruction.URL; else noLink"
       [href]="instruction.URL"
       target="_blank"
       rel="noopener noreferrer"
       class="instruction-container">
        <img 
            [src]="getImageUrl()" 
            [alt]="instruction.PAGE"
            class="instruction-image"
        />
    </a>
    <ng-template #noLink>
        <div class="instruction-container">
            <img 
                [src]="getImageUrl()" 
                [alt]="instruction.PAGE"
                class="instruction-image"
            />
        </div>
    </ng-template>
</ng-container>
